import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/SiteQueryForm'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Site Query Form'}
        >
            <Component 
            />
        </Layout>
    )
}

export default BlockInspectionStatusMasterlist